import { render, staticRenderFns } from "./moveSplit.vue?vue&type=template&id=66ab14ee&"
import script from "./moveSplit.vue?vue&type=script&lang=js&"
export * from "./moveSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports